import axios from "axios";
import { LogsAnswer } from "../types";
import { authHeader, hasAuth } from "./auth.header";

/* -------------------------------------------------------------------------------- *\
|                               auth interceptor
\* -------------------------------------------------------------------------------- */
// If any API call comes back 401/403 (e.g. the JWT is expired or invalid), drop the
// session and send the user back to the login page. Ignore the signin call itself so
// a wrong password stays on the login form with its error message.
axios.interceptors.response.use(
    (response) => response,
    (error) =>
    {
        const status = error?.response?.status;
        const url: string = error?.config?.url || '';
        if ((status === 401 || status === 403) && !url.includes('/api/signin'))
        {
            localStorage.removeItem('user');
            if (window.location.pathname !== '/login')
            {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
    if (process.env.REACT_APP__API_URL) return process.env.REACT_APP__API_URL;

    // In dev the front runs on :3000/:3001, the API on :5023.
    const origin: string = window.location.origin;
    return origin.replace('3000', '5023').replace('3001', '5023');
}
/* -------------------------------------------------------------------------------- *\
|                               get_logs
\* -------------------------------------------------------------------------------- */
export const get_logs = async (lines: number, date?: string): Promise<LogsAnswer> =>
{
    if (!hasAuth()) return Promise.resolve({ file: '', count: 0, lines: [] });

    const params: any = { lines };
    if (date) params.date = date;

    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/logs`, { params, headers: authHeader() }))
        .then(response => response.data as LogsAnswer);
}
